/* ---------------------- DUMMY DATA (V4 STRUCTURE) ---------------------- */
    
const consentRequests = [
  { from: "Tata Motors", type: "Print Capability", time: "30 min", status: "pending" },
  { from: "HDFC Bank", type: "Finance Verify", time: "1 day", status: "pending" },
];

const myRequests = [
  { to: "Infosys", type: "Job Verification", status: "pending" },
  { to: "University", type: "Transcript", status: "approved" },
];

const completedWork = [
  { action: "Print executed", place: "Cyber Cafe" },
  { action: "Health shared", place: "Apollo" },
  { action: "Finance verified", place: "ICICI" },
];

const eventStream = [
  "consent_requested → Tata Motors → Capability",
  "consent_granted → HDFC Bank → Finance",
  "action_executed → Print → Cyber Cafe",
  "consent_revoked → Apollo Hospital → Health",
];

const capabilityData = {
  labels: [
    "Lean Thinking",
    "Root Cause",
    "Systems Thinking",
    "Leadership",
    "Operational Reasoning",
    "Consistency",
  ],
  datasets: [
    {
      label: "Capability Score",
      data: [92, 88, 79, 84, 91, 82],
      backgroundColor: "rgba(37, 99, 235, 0.2)",
      borderColor: "rgba(37, 99, 235, 1)",
      borderWidth: 2,
    },
  ],
};

const capabilityOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    r: { min: 0, max: 100, ticks: { display: false } },
  },
};

const DOCUMENTS = [
  {
    category: "Education Records",
    icon: "🎓",
    color: "text-blue-700",
    items: [
        {
        id: "DOC-EDU-001",
        name: "Degree Certificate - B.Tech Mechanical",
        type: "education",

        version: "v1.0",
        description: "Final degree certificate issued after completion of B.Tech in Mechanical Engineering.",

        fileName: "degree_btech_mechanical.pdf",
        filePath: "/uploads/anugya/education/degree_btech_mechanical.pdf",
        fileKey: "education/degree_btech_mechanical.pdf",
        mimeType: "application/pdf",
        fileSize: "842 KB",
        storageType: "local",

        consentEnabled: true,
        accessEntities: ["University", "Employer"],
        actions: ["open", "share", "copy_link", "view_access_log", "audit"],
        createdAt: "2024-06-10"
        },
        {
        id: "DOC-EDU-002",
        name: "Semester Marksheet - Semester 6",
        type: "education",

        version: "v1.0",
        description: "Official marksheet for semester 6 examinations issued by university.",

        storageType: "local",
        fileName: "sem6_marksheet.pdf",
        filePath: "/uploads/anugya/education/sem6_marksheet.pdf",
        fileKey: "education/sem6_marksheet.pdf",
        mimeType: "application/pdf",
        fileSize: "512 KB",

        consentEnabled: false,
        accessEntities: ["Self"],
        actions: ["open", "download", "copy_link"],
        createdAt: "2024-05-22"
        },
        {
        id: "DOC-EDU-003",
        name: "AICTE Internship Certificate",
        type: "education",

        version: "v1.0",
        description: "Internship completion certificate issued under AICTE approved program.",

        storageType: "local",
        fileName: "aicte_internship_certificate.pdf",
        filePath: "/uploads/anugya/education/aicte_internship_certificate.pdf",
        fileKey: "education/aicte_internship_certificate.pdf",
        mimeType: "application/pdf",
        fileSize: "1.2 MB",

        consentEnabled: true,
        accessEntities: ["AICTE", "Employer"],
        actions: ["open", "share", "verify", "audit"],
        createdAt: "2024-07-01"
        },
        {
        id: "DOC-EDU-004",
        name: "Lean Six Sigma Yellow Belt",
        type: "skill",

        version: "v1.0",
        description: "Certification for Lean Six Sigma Yellow Belt demonstrating process improvement skills.",

        fileName: "lean_six_sigma_yellow_belt.pdf",
        filePath: "/uploads/anugya/education/lean_six_sigma_yellow_belt.pdf",
        fileKey: "education/lean_six_sigma_yellow_belt.pdf",
        mimeType: "application/pdf",
        fileSize: "980 KB",
        storageType: "local",

        consentEnabled: true,
        accessEntities: ["Training Institute", "Employer"],
        actions: ["open", "verify", "share", "audit"],
        createdAt: "2024-08-15"
        }
    ]
  },

  {
  category: "Employment Records",
  icon: "🏢",
  color: "text-green-700",
  items: [
    {
      id: "DOC-EMP-001",
      name: "Tata Motors - Experience Letter",
      type: "employment",

      version: "v1.0",
      description: "Official experience letter confirming employment tenure and role at Tata Motors.",

      fileName: "tata_experience_letter.pdf",
      filePath: "/uploads/anugya/employment/tata_experience_letter.pdf",
      fileKey: "employment/tata_experience_letter.pdf",
      mimeType: "application/pdf",
      fileSize: "1.1 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Tata Motors", "Employer"],
      actions: ["open", "share", "verify", "audit"],
      createdAt: "2023-11-20"
    },
    {
      id: "DOC-EMP-002",
      name: "Infosys Internship Completion",
      type: "employment",

      version: "v1.0",
      description: "Internship completion certificate issued by Infosys after successful training program.",

      fileName: "infosys_internship.pdf",
      filePath: "/uploads/anugya/employment/infosys_internship.pdf",
      fileKey: "employment/infosys_internship.pdf",
      mimeType: "application/pdf",
      fileSize: "640 KB",
      storageType: "local",

      consentEnabled: false,
      accessEntities: ["Infosys"],
      actions: ["open", "download"],
      createdAt: "2023-09-18"
    },
    {
      id: "DOC-EMP-003",
      name: "Mahindra Logistics Offer Letter",
      type: "employment",

      version: "v1.0",
      description: "Official offer letter issued by Mahindra Logistics detailing role and joining terms.",

      fileName: "mahindra_offer_letter.pdf",
      filePath: "/uploads/anugya/employment/mahindra_offer_letter.pdf",
      fileKey: "employment/mahindra_offer_letter.pdf",
      mimeType: "application/pdf",
      fileSize: "720 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Mahindra Logistics"],
      actions: ["open", "share", "revoke", "audit"],
      createdAt: "2023-07-05"
    },
    {
      id: "DOC-EMP-004",
      name: "HR Verification Record",
      type: "employment",

      version: "v1.0",
      description: "Internal HR verification record used for background and employment validation.",

      fileName: "hr_verification_record.pdf",
      filePath: "/uploads/anugya/employment/hr_verification_record.pdf",
      fileKey: "employment/hr_verification_record.pdf",
      mimeType: "application/pdf",
      fileSize: "410 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["HR System"],
      actions: ["open", "view_access_log", "audit"],
      createdAt: "2023-06-12"
    }
  ]
},

  {
  category: "Capability Evidence",
  icon: "🧠",
  color: "text-purple-700",
  items: [
    {
      id: "DOC-CAP-001",
      name: "Think5Whys DPIIT Recognition",
      type: "capability",
      version: "1.0",
      description: "DPIIT recognition certificate for Think5Whys platform validating startup recognition.",

      fileName: "Think5Whys-DPIIT-260988.pdf",
      filePath: "/uploads/anugya/capability/Think5Whys-DPIIT-260988.pdf",
      fileKey: "capability/Think5Whys-DPIIT-260988.pdf",
      mimeType: "application/pdf",
      fileSize: "2.3 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["AI Engine"],
      actions: ["open", "analyze", "audit"],
      createdAt: "2025-01-10"
    },
    {
      id: "DOC-CAP-002",
      name: "Root Cause Analysis Project",
      type: "capability",
      version: "1.0",
      description: "Project demonstrating structured root cause analysis methodology and reasoning framework.",

      fileName: "rca_project.pdf",
      filePath: "/uploads/anugya/capability/rca_project.pdf",
      fileKey: "capability/rca_project.pdf",
      mimeType: "application/pdf",
      fileSize: "1.4 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Mentor", "AI Engine"],
      actions: ["open", "share", "insights"],
      createdAt: "2024-10-12"
    },
    {
      id: "DOC-CAP-003",
      name: "Lean Thinking Assessment Score",
      type: "capability",
      version: "1.0",
      description: "Assessment report measuring lean thinking capability and decision efficiency score.",

      fileName: "lean_score.pdf",
      filePath: "/uploads/anugya/capability/lean_score.pdf",
      fileKey: "capability/lean_score.pdf",
      mimeType: "application/pdf",
      fileSize: "300 KB",
      storageType: "local",

      consentEnabled: false,
      accessEntities: ["Self"],
      actions: ["open", "view_score"],
      createdAt: "2024-09-05"
    },
    {
      id: "DOC-CAP-004",
      name: "Behavioral Consistency Index",
      type: "capability",
      version: "1.0",
      description: "AI-driven behavioral consistency measurement across decision patterns and actions.",

      fileName: "behavioral_index.pdf",
      filePath: "/uploads/anugya/capability/behavioral_index.pdf",
      fileKey: "capability/behavioral_index.pdf",
      mimeType: "application/pdf",
      fileSize: "890 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["AI Analytics"],
      actions: ["open", "audit", "trend_analysis"],
      createdAt: "2024-11-01"
    }
  ]
},

  {
  category: "Financial Records",
  icon: "💰",
  color: "text-orange-700",
  items: [
    {
      id: "DOC-FIN-001",
      name: "Bank Verification Statement",
      type: "finance",
      version: "1.0",
      description: "Official bank verification statement confirming account ownership and financial identity.",

      fileName: "bank_verification.pdf",
      filePath: "/uploads/anugya/finance/bank_verification.pdf",
      fileKey: "finance/bank_verification.pdf",
      mimeType: "application/pdf",
      fileSize: "650 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Bank", "Employer"],
      actions: ["open", "share", "verify"],
      createdAt: "2024-03-12"
    },
    {
      id: "DOC-FIN-002",
      name: "Income Certificate",
      type: "finance",
      version: "1.0",
      description: "Government-issued income certificate used for financial and eligibility verification purposes.",

      fileName: "income_certificate.pdf",
      filePath: "/uploads/anugya/finance/income_certificate.pdf",
      fileKey: "finance/income_certificate.pdf",
      mimeType: "application/pdf",
      fileSize: "520 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Govt Authority"],
      actions: ["open", "download", "verify"],
      createdAt: "2024-02-25"
    },
    {
      id: "DOC-FIN-003",
      name: "Credit Score Report",
      type: "finance",
      version: "1.0",
      description: "Credit bureau report showing credit score, repayment behavior, and financial risk profile.",

      fileName: "credit_score.pdf",
      filePath: "/uploads/anugya/finance/credit_score.pdf",
      fileKey: "finance/credit_score.pdf",
      mimeType: "application/pdf",
      fileSize: "380 KB",
      storageType: "local",

      consentEnabled: false,
      accessEntities: ["Self"],
      actions: ["open", "view_score"],
      createdAt: "2024-01-15"
    },
    {
      id: "DOC-FIN-004",
      name: "Tax Filing Summary",
      type: "finance",
      version: "1.0",
      description: "Summary of filed tax returns and compliance records for financial year reporting.",

      fileName: "tax_filing_summary.pdf",
      filePath: "/uploads/anugya/finance/tax_filing_summary.pdf",
      fileKey: "finance/tax_filing_summary.pdf",
      mimeType: "application/pdf",
      fileSize: "1.0 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Tax Authority"],
      actions: ["open", "audit", "download"],
      createdAt: "2024-04-10"
    }
  ]
},

  {
  category: "Health Records",
  icon: "🏥",
  color: "text-red-700",
  items: [
    {
      id: "DOC-HLTH-001",
      name: "ABHA Health ID",
      type: "health",
      version: "1.0",
      description: "Ayushman Bharat Health Account (ABHA) ID used for digital health record linking across hospitals and insurers.",

      fileName: "abha_health_id.pdf",
      filePath: "/uploads/anugya/health/abha_health_id.pdf",
      fileKey: "health/abha_health_id.pdf",
      mimeType: "application/pdf",
      fileSize: "210 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Hospital", "Insurance"],
      actions: ["open", "share", "audit"],
      createdAt: "2024-02-01"
    },
    {
      id: "DOC-HLTH-002",
      name: "Vaccination Certificate",
      type: "health",
      version: "1.0",
      description: "Official vaccination certificate confirming administered vaccines and immunization history.",

      fileName: "vaccination_certificate.pdf",
      filePath: "/uploads/anugya/health/vaccination_certificate.pdf",
      fileKey: "health/vaccination_certificate.pdf",
      mimeType: "application/pdf",
      fileSize: "340 KB",
      storageType: "local",

      consentEnabled: false,
      accessEntities: ["Self"],
      actions: ["open", "download"],
      createdAt: "2024-03-08"
    },
    {
      id: "DOC-HLTH-003",
      name: "Medical Test Reports",
      type: "health",
      version: "1.0",
      description: "Diagnostic medical test reports including pathology, blood tests, and clinical assessments.",

      fileName: "medical_reports.pdf",
      filePath: "/uploads/anugya/health/medical_reports.pdf",
      fileKey: "health/medical_reports.pdf",
      mimeType: "application/pdf",
      fileSize: "2.1 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Hospital"],
      actions: ["open", "share", "verify"],
      createdAt: "2024-05-20"
    },
    {
      id: "DOC-HLTH-004",
      name: "Insurance Policy Document",
      type: "health",
      version: "1.0",
      description: "Health insurance policy document outlining coverage, benefits, and claim terms.",

      fileName: "insurance_policy.pdf",
      filePath: "/uploads/anugya/health/insurance_policy.pdf",
      fileKey: "health/insurance_policy.pdf",
      mimeType: "application/pdf",
      fileSize: "780 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Insurance Provider"],
      actions: ["open", "audit", "download"],
      createdAt: "2024-06-11"
    }
  ]
},

  {
  category: "Business Documents",
  icon: "📄",
  color: "text-indigo-700",
  items: [
    {
      id: "DOC-BUS-001",
      name: "Bill No: 26/178 - Vendor Payment Invoice",
      type: "business",
      version: "1.0",
      description: "Vendor payment invoice issued for procurement settlement under accounts payable process.",

      fileName: "bill_26_178.pdf",
      filePath: "/uploads/anugya/business/bill_26_178.pdf",
      fileKey: "business/bill_26_178.pdf",
      mimeType: "application/pdf",
      fileSize: "1.3 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Vendor", "Accounts Dept"],
      actions: ["open", "share", "approve_payment", "audit"],
      createdAt: "2026-01-10"
    },
    {
      id: "DOC-BUS-002",
      name: "Receipt No: R/100 - Office Purchase Settlement",
      type: "business",
      version: "1.0",
      description: "Receipt confirming settlement of office purchase expenses and internal finance reconciliation.",

      fileName: "receipt_r100.pdf",
      filePath: "/uploads/anugya/business/receipt_r100.pdf",
      fileKey: "business/receipt_r100.pdf",
      mimeType: "application/pdf",
      fileSize: "540 KB",
      storageType: "local",

      consentEnabled: false,
      accessEntities: ["Finance Team"],
      actions: ["open", "download"],
      createdAt: "2026-01-05"
    },
    {
      id: "DOC-BUS-003",
      name: "Purchase Bill: PUR/26/0001 - Equipment Procurement",
      type: "business",
      version: "1.0",
      description: "Purchase order invoice for equipment procurement under approved vendor contract.",

      fileName: "purchase_bill_0001.pdf",
      filePath: "/uploads/anugya/business/purchase_bill_0001.pdf",
      fileKey: "business/purchase_bill_0001.pdf",
      mimeType: "application/pdf",
      fileSize: "1.8 MB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Procurement", "Vendor"],
      actions: ["open", "verify", "audit"],
      createdAt: "2026-01-12"
    },
    {
      id: "DOC-BUS-004",
      name: "GST Invoice: GST/INV/88291 - Service Billing",
      type: "business",
      version: "1.0",
      description: "GST compliant invoice for service billing with tax breakdown and compliance details.",

      fileName: "gst_invoice_88291.pdf",
      filePath: "/uploads/anugya/business/gst_invoice_88291.pdf",
      fileKey: "business/gst_invoice_88291.pdf",
      mimeType: "application/pdf",
      fileSize: "920 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["GST Portal", "Accounts"],
      actions: ["open", "share", "tax_audit"],
      createdAt: "2026-01-14"
    },
    {
      id: "DOC-BUS-005",
      name: "Expense Voucher: EXP/44/2026 - Operational Cost Record",
      type: "business",
      version: "1.0",
      description: "Operational expense voucher for reimbursement and internal financial audit tracking.",

      fileName: "expense_voucher_44_2026.pdf",
      filePath: "/uploads/anugya/business/expense_voucher_44_2026.pdf",
      fileKey: "business/expense_voucher_44_2026.pdf",
      mimeType: "application/pdf",
      fileSize: "610 KB",
      storageType: "local",

      consentEnabled: true,
      accessEntities: ["Finance Head"],
      actions: ["open", "audit", "reimbursement"],
      createdAt: "2026-01-16"
    }
  ]
}
];

const CONSENTS = [
  {
    id: "CNS-001",
    docId: "DOC-EMP-001",
    entity: "Tata Motors",
    purpose: "Employment Verification",

    status: "active",

    duration: "30 days",
    startDate: "2026-01-01",
    endDate: "2026-01-31",

    accessLevel: "read-only",
    allowedActions: ["view", "verify", "download"],

    channel: "employer-verification",

    riskLevel: "low",

    // ================= AI INTELLIGENCE LAYER =================
    aiScore: 0.18, // 0 = safe, 1 = risky
    aiDecision: "allow", // allow | restrict | monitor | block
    aiReason: "Standard employment verification, trusted entity",

    policyId: "POL-EMPLOYER-STD-01",

    anomalyScore: 0.05, // abnormal access behavior detection
    anomalyFlags: [],

    decisionTrace: [
      {
        step: "policy_check",
        result: "pass"
      },
      {
        step: "entity_trust_score",
        result: "high_trust"
      }
    ],

    createdAt: "2026-01-01",
    lastAccessedAt: "2026-01-10"
  },

  {
    id: "CNS-002",
    docId: "DOC-FIN-002",
    entity: "HDFC Bank",
    purpose: "Financial Assessment",

    status: "active",

    duration: "1 day",
    startDate: "2026-01-15",
    endDate: "2026-01-16",

    accessLevel: "read-only",
    allowedActions: ["view", "download"],

    channel: "financial-verification",

    riskLevel: "medium",

    aiScore: 0.42,
    aiDecision: "monitor",
    aiReason: "Financial data exposure increases sensitivity",

    policyId: "POL-FIN-RESTRICTED-02",

    anomalyScore: 0.22,
    anomalyFlags: ["short_duration_high_frequency_check"],

    decisionTrace: [
      {
        step: "policy_check",
        result: "pass"
      },
      {
        step: "data_sensitivity",
        result: "medium_risk"
      }
    ],

    createdAt: "2026-01-15",
    lastAccessedAt: null
  },

  {
    id: "CNS-003",
    docId: "DOC-CAP-003",
    entity: "NSDC",
    purpose: "Skill Mapping",

    status: "active",

    duration: "7 days",
    startDate: "2026-01-05",
    endDate: "2026-01-12",

    accessLevel: "analyze",
    allowedActions: ["view", "analyze", "score"],

    channel: "skill-verification",

    riskLevel: "low",

    aiScore: 0.12,
    aiDecision: "allow",
    aiReason: "Public skill verification dataset",

    policyId: "POL-SKILL-STD-01",

    anomalyScore: 0.08,
    anomalyFlags: [],

    decisionTrace: [
      {
        step: "policy_check",
        result: "pass"
      }
    ],

    createdAt: "2026-01-05",
    lastAccessedAt: "2026-01-09"
  },

  {
    id: "CNS-004",
    docId: "DOC-HLTH-004",
    entity: "Apollo Hospital",
    purpose: "Health Record Access",

    status: "revoked",

    duration: "expired",
    startDate: "2025-12-01",
    endDate: "2025-12-10",

    accessLevel: "read-only",
    allowedActions: ["view"],

    channel: "health-records",

    riskLevel: "high",

    aiScore: 0.89,
    aiDecision: "blocked",
    aiReason: "Sensitive health data + expired consent",

    policyId: "POL-HEALTH-HIGH-01",

    anomalyScore: 0.61,
    anomalyFlags: ["access_after_revocation", "health_sensitive_data"],

    decisionTrace: [
      {
        step: "policy_check",
        result: "fail_expired"
      },
      {
        step: "compliance_layer",
        result: "blocked"
      }
    ],

    createdAt: "2025-12-01",
    revokedAt: "2025-12-05",
    lastAccessedAt: "2025-12-04"
  },

  {
    id: "CNS-005",
    docId: "DOC-EMP-002",
    entity: "Infosys",
    purpose: "Job Verification",

    status: "pending",

    duration: "3 days",
    startDate: "2026-01-20",
    endDate: "2026-01-23",

    accessLevel: "read-only",
    allowedActions: ["view", "verify"],

    channel: "employment-verification",

    riskLevel: "low",

    aiScore: 0.33,
    aiDecision: "monitor",
    aiReason: "Pending approval, not yet activated",

    policyId: "POL-EMPLOYER-STD-01",

    anomalyScore: 0.12,
    anomalyFlags: ["pending_state"],

    decisionTrace: [
      {
        step: "policy_check",
        result: "pending_activation"
      }
    ],

    createdAt: "2026-01-20",
    lastAccessedAt: null
  }
];

const ACCESS_LOG = [
  { id: 1, date: "2026-05-15 10:12 AM", name: "Rahul Mehta" },
  { id: 2, date: "2026-05-14 04:30 PM", name: "Tata HR System" },
  { id: 3, date: "2026-05-13 09:05 AM", name: "Infosys Verification Bot" },
];

const CONSENT_LIST = [
  {
    id: 1,
    date: "2026-05-12 11:00 AM",
    name: "HDFC Bank",
    type: "Financial Verification",
    remarks: "Loan eligibility check",
  },
  {
    id: 2,
    date: "2026-05-10 02:15 PM",
    name: "Tata Motors",
    type: "Employment Screening",
    remarks: "Hiring assessment",
  },
  {
    id: 3,
    date: "2026-05-08 06:40 PM",
    name: "NSDC Portal",
    type: "Skill Verification",
    remarks: "National skill mapping",
  },
];

const ACTION_LIST = [
  {
    id: 1,
    date: "2026-05-15 10:15 AM",
    name: "Rahul Mehta",
    action: "Opened",
  },
  {
    id: 2,
    date: "2026-05-14 04:35 PM",
    name: "HDFC Bank",
    action: "Downloaded",
  },
  {
    id: 3,
    date: "2026-05-13 09:10 AM",
    name: "Tata HR System",
    action: "Shared",
  },
  {
    id: 4,
    date: "2026-05-13 09:45 AM",
    name: "CyberCafe Node",
    action: "Printed",
  },
];

const USER_DB = {
  T5W1001: { name: "Rahul Mehta" },
  T5W1002: { name: "Priya Sharma" },
  T5W1003: { name: "Amit Verma" },
};

const AnugyaTestDummyData = {
  consentRequests,
  myRequests,
  completedWork,
  eventStream,
  DOCUMENTS,
  CONSENTS,
  ACCESS_LOG,
  CONSENT_LIST,
  ACTION_LIST,
  USER_DB
};

export default AnugyaTestDummyData;